module.exports = "/shifts/components/absenceView-7779cc.html";